import { enableProdMode, LOCALE_ID, DEFAULT_CURRENCY_CODE, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatDialogModule } from '@angular/material/dialog';
import { HioUserinfoModule } from '@hio/userinfo';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { routing } from './app/app.routing';
import { withInterceptorsFromDi, provideHttpClient, withXhr } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import { JApiModule, HIO_ZONELESS } from '@j/api';

if (environment.production) {
  enableProdMode();
}
registerLocaleData(localeDE, 'de');
bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
        { provide: HIO_ZONELESS, useValue: true },importProvidersFrom(BrowserModule, FormsModule, routing, FontAwesomeModule, HioUserinfoModule, MatDialogModule, JApiModule
    // DropzoneModule.forRoot(DROPZONE_CONFIG)
    ),
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' }
    // JBetriebService,
    // JSystemService,
    ,
    provideAnimations(),
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
  .catch(err => console.error(err));
